customerApplication = {
  init: function init() {
    scrollToFirstInvalidElement($("#customerApplicationForm"));

    //Hide service provider fields from start
    $("#serviceProvider-wrapper").hide();
    $("#customerApplicationForm").submit(function (e) {
      e.preventDefault();

      //Hide the error messages if they are already showing from last validation.
      $("#businessEntity-error").hide();
      $("#businessClassification-error").hide();
      $("#typeOfCustomer-error").hide();
      $("#serviceProviderProductTypes-error").hide();
      var formValid = $("#customerApplicationForm").valid();
      var termsCheckboxesNotValid = $(".customerApplication-termsCheckbox:not(:checked)").length;
      if (termsCheckboxesNotValid) {
        $(".customerApplication-termsCheckbox:not(:checked)").each(function () {
          $(this).siblings(".customerApplication-validationError").show();
        });
      }

      //Validates if at least one checkbox is checked.
      function checkIfAnyCheckboxIsChecked(checkBoxList) {
        var alternatives = checkBoxList.children();
        for (var i = 0; i < alternatives.length; i++) {
          var checked = alternatives.find("input[type='checkbox']").is(":checked");
          if (checked) {
            return true;
            break;
          }
        }
        return false;
      }

      //Checkbox lists
      var businessEntities = $("#businessEntity");
      var businessClassification = $("#businessClassification");
      var typeOfCustomer = $("#typeOfCustomer");
      var serviceProviderProductTypes = $("#serviceProviderProductTypes");
      if (!checkIfAnyCheckboxIsChecked(businessEntities)) {
        formValid = false;
        $(businessEntities).next(".customerApplication-validationError").show();
      }
      if (!checkIfAnyCheckboxIsChecked(businessClassification)) {
        formValid = false;
        $(businessClassification).next(".customerApplication-validationError").show();
      }
      if (!checkIfAnyCheckboxIsChecked(typeOfCustomer)) {
        formValid = false;
        $(typeOfCustomer).next(".customerApplication-validationError").show();
      }
      var isServiceProvider = $("#areYouAServiceProvider").is(":checked");
      if (isServiceProvider) {
        if (!checkIfAnyCheckboxIsChecked(serviceProviderProductTypes)) {
          formValid = false;
          $(serviceProviderProductTypes).next(".customerApplication-validationError").show();
        }
      }
      var form = this;
      var filesValid = true;
      // "image/jpeg,image/png,image/gif,text/plain,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      var allowedExtensionsRegx = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf|\.doc|\.docx|\.xls|\.xlsx|\.csv|\.txt)$/i;
      for (var i = 0; i < form.elements.length; i++) {
        var element = form.elements[i];
        if (element.type === 'file') {
          var fileNames = [];
          for (var j = 0; j < element.files.length; j++) {
            // validate file size
            if (element.files[j].size / 1024 / 1024 > 10) {
              $("#" + element.name + "-error-size").show();
              filesValid = false;
            }
            // validate file extension
            var filename = element.files[j].name;
            var extension = filename.substr(filename.lastIndexOf("."));
            if (!allowedExtensionsRegx.test(extension)) {
              $("#" + element.name + "-error-type").show();
              filesValid = false;
            }
          }
        }
      }
      if (!formValid || termsCheckboxesNotValid || !filesValid) {
        scrollToFirstInvalidElement($("#customerApplicationForm"));
        return;
      }
      $(form).find(".customerApplication-error").hide();
      $(form).find("button[type='submit']").attr("disabled", "disabled");
      var token = $('input[name="__RequestVerificationToken"]', form).val();
      var formData = new FormData();
      formData.append('sc-language', $("body").data('sc-language'));
      formData.append('__RequestVerificationToken', token);
      for (var i = 0; i < form.elements.length; i++) {
        var _element = form.elements[i];
        if (_element.type === 'checkbox') {
          if (formData.get(_element.name)) {
            if (_element.checked) formData.set(_element.name, formData.get(_element.name) + ", " + $(_element).data("id"));
          } else if (form.elements[_element.name].length > 1) {
            if (_element.checked) formData.append(_element.name, $(_element).data("id"));
          } else {
            formData.append(_element.name, _element.checked);
          }
        } else if (_element.type === 'file') {
          var fileNames = [];
          for (var j = 0; j < _element.files.length; j++) {
            fileNames.push(_element.files[j].name);
            formData.append(_element.name + j, _element.files[j]);
          }
          formData.append(_element.name + "FileNames", fileNames.join());
        } else {
          formData.append(_element.name, _element.value);
        }
      }
      $.ajax({
        url: "/api/edometic/customerapplication/submit",
        type: 'POST',
        data: formData,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function success(result) {
          $(form).hide("", function () {
            $(".customerApplication-success").show("slow");
          });
        },
        error: function error(_error) {
          $(form).find(".customerApplication-error").show('slow');
          $(form).find("button[type='submit']").removeAttr("disabled").removeClass("disabled");
        }
      });
    });
    $("#areYouAServiceProvider").change(function () {
      if ($("#areYouAServiceProvider").is(":checked")) {
        $("#serviceProvider-wrapper").show();
        $("#mobileService").prop('required', true);
        $("#warrantyLaborRate").prop('required', true);
        $("#operationHours").prop('required', true);
        $("#serviceArea").prop('required', true);
      } else {
        $("#serviceProvider-wrapper").hide();
        $("#serviceProvider-wrapper").find("input").val("");
        $("#mobileService").removeAttr('required');
        $("#warrantyLaborRate").removeAttr('required');
        $("#operationHours").removeAttr('required');
        $("#serviceArea").removeAttr('required');
        //var checkboxes = $("#serviceProviderProductTypes").children();
        //for (var i = 0; i < checkboxes.length; i++) {
        //    $(checkboxes[i]).find(".customerApplication-checkbox").prop("checked", false);
        //}
      }
    });
    $("#paymentType").change(function () {
      if ($(this).val().toLowerCase().includes("credit")) $("#ifOpenCredit").prop('required', true);else {
        $("#ifOpenCredit").removeAttr('required');
      }
    });
    $("#onlineRetailer").change(function () {
      if ($(this).val().toLowerCase().includes("yes")) {
        $("#websiteURL").prop('required', true);
        $("#resaleCertificate").prop('required', true);
      } else {
        $("#websiteURL").removeAttr('required');
        $("#resaleCertificate").removeAttr('required');
      }
    });
    $("#mobileService").change(function () {
      if ($(this).val().toLowerCase().includes("yes")) $("#ifMobileService").prop('required', true);else {
        $("#ifMobileService").removeAttr('required');
      }
    });
    $("#buyerAgreement-link").click(function (e) {
      e.preventDefault();
      var forId = $(this).closest("label").prop("for");
      var $checkbox = $("#" + forId);
      customerApplication.termsCheckboxClick($checkbox);
    });
    $("#serviceCenterAgreement-link").click(function (e) {
      e.preventDefault();
      var forId = $(this).closest("label").prop("for");
      var $checkbox = $("#" + forId);
      customerApplication.termsCheckboxClick($checkbox);
    });
    $("#saleTerms-link").click(function (e) {
      e.preventDefault();
      var forId = $(this).closest("label").prop("for");
      var $checkbox = $("#" + forId);
      customerApplication.termsCheckboxClick($checkbox);
    });
    $("#buyerAgreement").keydown(function (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        e.preventDefault();
        customerApplication.setCheckboxValue($("#buyerAgreement-label"), e);
      }
    });
    $("#buyerAgreement-label").keydown(function (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        e.preventDefault();
        customerApplication.setCheckboxValue(this, e);
      }
    });
    $("#buyerAgreement-label").click(function (e) {
      e.preventDefault();
      customerApplication.setCheckboxValue(this, e);
    });
    $("#taxAgreement-label").click(function (e) {
      $(this).siblings(".customerApplication-validationError").hide();
    });
    $("#serviceCenterAgreement").keydown(function (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        e.preventDefault();
        customerApplication.setCheckboxValue($("#serviceCenterAgreement-label"), e);
      }
    });
    $("#serviceCenterAgreement-label").click(function (e) {
      e.preventDefault();
      customerApplication.setCheckboxValue(this, e);
    });
    $("#serviceCenterAgreement-label").keydown(function (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        e.preventDefault();
        customerApplication.setCheckboxValue(this, e);
      }
    });
    $("#saleTerms").keydown(function (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        e.preventDefault();
        customerApplication.setCheckboxValue($("#saleTerms-label"), e);
      }
    });
    $("#saleTerms-label").click(function (e) {
      e.preventDefault();
      customerApplication.setCheckboxValue(this, e);
    });
    $("#saleTerms-label").keydown(function (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        e.preventDefault();
        customerApplication.setCheckboxValue(this, e);
      }
    });
  },
  termsCheckboxClick: function termsCheckboxClick($checkbox) {
    $checkbox.siblings("label").removeClass("disabled");
    $(".customerApplication-modalTitle").hide();
    $(".customerApplication-modalText").hide();
    $(".customerApplication-" + $checkbox.prop("name") + "-modal").show();
    $checkbox.attr("data-hasRead", 1);
    $("#customerApplicationModal").modal();
  },
  setCheckboxValue: function setCheckboxValue(element, event) {
    $(element).siblings(".customerApplication-validationError").hide();
    var forId = $(element).prop("for");
    var $checkbox = $("#" + forId);
    if ($checkbox.attr("data-hasread") == 1) {
      if ($checkbox.is(":checked")) {
        $checkbox.prop('checked', false);
        return;
      } else {
        $checkbox.prop('checked', true);
        return;
      }
      return;
    } else {
      customerApplication.termsCheckboxClick($checkbox);
    }
  }
};
$(document).ready(function () {
  customerApplication.init();
});